import { handleUnauthorizedRequests } from '../../../services/provider/authService';
import { type Middleware, type MiddlewareAPI } from '@reduxjs/toolkit';

type RejectedAction = {
  payload?: {
    status?: number;
  };
};

const isUnauthorizedError = (action: RejectedAction): boolean => {
  const { status } = action.payload ?? {};
  return status === 401;
};

export const apiServiceErrorHandlerMiddleware: Middleware =
  // eslint-disable-next-line unicorn/consistent-function-scoping
  (_api: MiddlewareAPI) => (next) => (action: unknown) => {
    if (isUnauthorizedError(action as RejectedAction)) {
      handleUnauthorizedRequests();
      return;
    }

    // eslint-disable-next-line consistent-return
    return next(action);
  };
